import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import AgregarCampo from "./AgregarCampo.js"

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"


var textareaStyle = {
    minHeight: '300px'
};

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solicitud_id: null,
            proyecto_codigo: "",
            campos: []
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            solicitud_id: data.solicitud_id,
            proyecto_codigo: data.solicitud_codigo,
            campos: data.campos
        });
    }

    resetState() {
        this.setState({
            solicitud_id: null,
            proyecto_codigo: "",
            campos: []
        });
    }

    onCheckBoxClick(i) {
        let campos = this.state.campos;
        campos[i].imprimir = (campos[i].imprimir ? false : true);
        this.setState({ campos: campos });
    }

    render() {
        return (
            <ParadigmaModal
                fileDownloader={true}
                fileName={"Plan de Trabajo.docx"}
                downloadUrl={api.proyectos.plandetrabajo.downloaddoc}
                getUrl={api.proyectos.plandetrabajo.generardoc}
                postUrl={api.proyectos.plandetrabajo.generardoc}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Documento del Plan de Trabajo ha sido generado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Generar Documento del Plan de Trabajo"}
                buttonTitle={"Generar Documento del Plan de Trabajo"}
                buttonIcon={"fa fa-file fa-lg"}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Código</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"codigo"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Proyecto</Label>
                    </Col>
                    <Col className="col-10">
                        <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col className="col-12">
                        <Label>Seleccione los datos a exportar</Label>
                        <table>
                            <thead>
                                <tr>
                                    <th>Pestañas</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.campos.map((x, i) =>
                                    <tr key={i}>
                                        <td>
                                            <Label>
                                                {!x.obligatorio ? <input readOnly={true} onChange={(e) => { return; }}
                                                    onClick={(value) => this.onCheckBoxClick(i)} type={"checkbox"} checked={x.imprimir} /> : null}
                                                {(x.imprimir || x.obligatorio) && <input hidden={true} value={x.id} name={"campos[" + i + "]"} />}
                                                {x.nombre}
                                            </Label>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento2/DescargarDoc.js